export default __webpack_public_path__ + "static/media/mg-title-en.57004349.webp";